import _ from 'lodash'
import * as selectors from './selectors'

const REPORTING_PAGE_NAME = "CDC NCIPC Opioid Dashboard"

/**
 * Utility class to interaction tracking with CDC Adobe Analytics library
 *
 * Requires main Analytics library to be loaded in index.html from a location like:
 * https://www.cdc.gov/JScript/metrics/adobe/analytics_cdcgov.js
 */
class Analytics {

  /**
   * Serializes an object into a standard format for interaction tracking.
   *
   * for example:
   * { name: "foo", label: "bar" } => "name=foo|label=bar"
   *
   * @example
   * const values = { name: "foo", label: "bar" }
   * serializeLabelValues(values) => "name=foo|label=bar"
   *
   * @param valueObject - object to serialize key/value pairs
   * @returns {*} - serialized string of key value pairs
   */
  serializeLabelValues(valueObject) {
    return _.chain(valueObject)
      .map((value, key) => `${key}=${value}`)
      .join("|")
      .value()
  }

  /**
   * Track interaction and send to DMAT analytics.
   *
   * @param {String} data Serialized data string sent to DMAT via `_satellite.track` call.
   */
  trackInteraction(data) {
    // eslint-disable-next-line no-undef
    if (typeof _satellite !== 'undefined' && typeof _satellite?.track === 'function') {
      // eslint-disable-next-line no-undef
      _satellite.track('interaction', data);
    }
  }

  /**
   * Sends a data object to DMAT Analytics to track the event "DOWNLOAD"
   * Includes properties for section (STATE,COUNTY,SUMMARY) extension (CSV) and selectedCost
   *
   * @param section
   * @param extension
   * @param store
   */
  trackDataExport(section, extension, store) {
    const values = this.serializeLabelValues({
      event: "EXPORT",
      sect: section,
      ext: extension,
      cost: selectors.getSelectedCost(store),
      ss: selectors.getSelectedStateFips(store),
      cs: selectors.getComparisonStateFips(store),
      sc: selectors.getSelectedCountyFips(store),
      cc: selectors.getComparisonCountyFips(store)
    });

    const data = {
      pageName: REPORTING_PAGE_NAME,
      pageType: 'Web Page',
      prop40: values,
    };

    this.trackInteraction(data);
  }

  /**
   * Sends a data object to DMAT Analytics to track the event "FILTER"
   * Includes properties for displayType, summaryType, selectedCost, selectedState,
   * comparisonState, selectedCounty, comparisonCounty.
   *
   * @param store
   */
  trackFiltersUpdate(store) {
    const values = this.serializeLabelValues({
      event: "FILTER",
      disp: selectors.getDisplayType(store),
      sum: selectors.getSummaryType(store),
      cost: selectors.getSelectedCost(store),
      ss: selectors.getSelectedStateFips(store),
      cs: selectors.getComparisonStateFips(store),
      sc: selectors.getSelectedCountyFips(store),
      cc: selectors.getComparisonCountyFips(store)
    });

    const data = {
      pageName: REPORTING_PAGE_NAME,
      pageType: 'Web Page',
      prop40: values,
    };

    this.trackInteraction(data);
  }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Analytics()
